import { mapFirstLink } from '../DataTypes/linkMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

interface Props extends Umbraco.BasePage {
	eventStartDate: string;
	eventEndDate?: string;
	eventLocation: { markup: string };
	eventPrice?: string;
	eventStatus?: { markup: string };
	eventSignupLink: Umbraco.Link[];
}

export const mapEventPageProperties = async (
	{ eventStartDate, eventEndDate, eventLocation, eventPrice, eventStatus, eventSignupLink, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.EventPageProperties> => {
	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			eventStartDate: eventStartDate,
			eventEndDate: eventEndDate || null,
			eventLocation: eventLocation?.markup ?? null,
			eventPrice: eventPrice ?? null,
			eventStatus: eventStatus?.markup ?? null,
			eventSignupLink: mapFirstLink(eventSignupLink) ?? null,
		};
	} catch (e) {
		logger.error('Could not map EventPage Properties', e);
		throw new Error('Could not map EventPage Properties', e);
	}
};
